import * as React from 'react';

import * as styles from './RowTitlePhotosField.css';

export const RowTitlePhotosField = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
